import { Component, Input } from '@angular/core';
import { CmsFilterIcon } from '../cms-filter-dropdown/cms-filter-icons';

@Component({
    selector: 'cms-outline-icon',
    templateUrl: './cms-outline-icon.component.html',
    styleUrls: ['./cms-outline-icon.component.scss'],
    standalone: false,
})
export class CmsOutlineIconComponent {
    @Input() icon: CmsFilterIcon | null = null;
    @Input() size = 16;
}
